import { mapActions } from 'pinia'
import DrawerLayout from "@/Shared/DrawerLayout.vue";
import {DataRecordsStore} from "@/Store/DataGatherings/DataRecordsStore";
import DataRecordExploreHeader from "@/Shared/DathaGatherings/Common/Records/DataRecordExploreHeader";
import DataRecordsTable from "@/Shared/DathaGatherings/Common/Records/DataRecordsTable";
import {DataGatheringsStore} from "@/Store/DataGatherings/DataGatheringsStore";

export default {
    components: {
        DataRecordsTable,
        DataRecordExploreHeader,
        DrawerLayout,
    },

    props: {
        dataGathering: {
            type: Object,
            default: {},
        },

        records: {
            type: Object,
            default: () => ({
                page: 1,
                max: 10,
                pages: null,
                total: null,
                items: [],
            }),
        },

        types: {
            type: Array,
            default: [],
        },

        academicPeriods: {
            type: Array,
            default: [],
        },
    },

    data: () => ({

    }),

    methods: {
        ...mapActions(DataRecordsStore, [
            'setDataGathering',
            'setDataRecords',
        ]),

        ...mapActions(DataGatheringsStore, [
            'setAcademicPeriods',
            'setTypes',
        ]),
    },

    computed: {

    },

    mounted() {
        this.setDataGathering(this.dataGathering);
        this.setDataRecords(this.records);
        this.setAcademicPeriods(this.academicPeriods);
        this.setTypes(this.types);
    },
};
